export default "__VITE_ASSET__9f1d8063__"